<template>
    <hts-modal
        :show="show"
        :title="$t('labels.businessModule.delete')"
        type="confirm"
        :content="$t('labels.businessModule.confirmDelete')"
        @hide="closeOverSide"
        @confirm="() => handleSubmit()" />
</template>
<script setup lang="ts">
import { $lodash } from '#imports'

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  business: {
    type: Object || Array
  }
})

const emits = defineEmits(['close', 'refreshTables', 'resetBusinessSelecteds'])

const closeOverSide = () => {
  emits('close')
}

const handleSubmit = $lodash.debounce(() => {
  const api = $urlAdmin.business.delete
  $api(api, { body: props.business }).then((data) => {
    const resData: any = data?.data?.value

    if (resData?.success) {
      emits('refreshTables')
      process.client && $toast().success($t('labels.deleteBusinessSuccess'))
      emits('resetBusinessSelecteds')
      emits('close')
    }
  })
}, 300)
</script>
